import React, { useState } from 'react';
import axios from 'axios';
import _path from 'ramda/src/path';
import Button from './Button';
import Mixpanel from '../../API/Mixpanel';
import Notifications from '../../API/Notifications';
import { MIXPANEL_INTENT, MIXPANEL_LAND } from '../../Constants';
import GeneralUtility from '../../utilities/generalUtility';

const TrackPhoneNumber = props => {
    const [revealPhone, setRevealPhone] = useState(false);

    const buttonText = props.btnText ? props.btnText : 'CALL ME'

    const handleRevealPhoneNumber = e => {
        e.preventDefault();

        if (!revealPhone) {
            setRevealPhone(true);
            const phoneView = Notifications.phoneview({ targetUserId: props.userId });
            phoneView
                .then(response => {
                    if (response.status !== 200) {
                        throw new Error(response.data.Message);
                    }
                })
                .catch(error => {
                    GeneralUtility.logWebRequestFailure(
                        error,
                        `send notification phone view is failed - pageType: ${window.pageType}`
                    );
                });

            const mixData = { type: 'reveal phone' };
            if (props.dataContext) {
                mixData.context = props.dataContext;
            }
            Mixpanel.add(MIXPANEL_INTENT, mixData);
        }
    };

    return (
        <a
            className="re-btn re-btn-small re-btn-subtle re-btn-full-width"
            data-testid="trackphonenumber"
            href={revealPhone ? `tel:${props.phoneNumber}` : '#'}
            onClick={handleRevealPhoneNumber}
        >
            {revealPhone ? props.phoneNumber : buttonText}
        </a>
    );
};

export default TrackPhoneNumber;
